var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { getEntity, getNestedOfType } from "@iteria-app/graphql-lowcode/esm/generate";
export function getProperties(entity) {
    return entity.properties;
}
export function createEntityFromIntrospection(introspection, entityName) {
    var entityType = getEntity(introspection.types, entityName);
    var props = [];
    var entity;
    if (entityType && entityType.fields) {
        entityType.fields.forEach(function (field) {
            var _a;
            var propName = field.name;
            var propType = (_a = getNestedOfType(field).name) !== null && _a !== void 0 ? _a : '';
            props = __spreadArray(__spreadArray([], props), [{ getName: function () { return propName; }, getType: function () { return propType; } }]);
        });
        entity = {
            getName: function () { return entityName; },
            properties: props
        };
    }
    return entity;
}
